import React from 'react';
import { Datagrid, DateField, Filter, List, SelectInput, TextField, TextInput } from 'react-admin';
import { BulkDeleteButtonAdmin, CustomPagination } from './utils';

const StationsTerminalFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'sno', name: 'Sno' },
                { id: 'prev', name: 'Старый терминал' },
                { id: 'curr', name: 'Новый терминал' },
                { id: 'created', name: 'Время создания' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const StationsTerminalList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<StationsTerminalFilter />}
        bulkActionButtons={<BulkDeleteButtonAdmin permissions={permissions} />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Sno"
                source="sno"
            />
            <TextField
                label="Старый терминал"
                source="prev"
            />
            <TextField
                label="Новый терминал"
                source="curr"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);
